import React from 'react';
import PropTypes from 'prop-types';

function TimeEntryIdCell({ dataItem, setModalState, colSpan, className, ariaColumnIndex, style }) {
  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected="false"
      style={style}>
      <button
        type="button"
        className="time-entry-id-cell__link"
        onClick={() => setModalState({ visible: true, timeEntryId: dataItem.id })}>
        {dataItem.id}
      </button>
    </td>
  );
}

TimeEntryIdCell.propTypes = {
  ariaColumnIndex: PropTypes.number.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  colSpan: PropTypes.number.isRequired,
  dataItem: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  setModalState: PropTypes.func.isRequired
};

TimeEntryIdCell.defaultProps = {
  style: null,
  className: ''
};

export default TimeEntryIdCell;
